import { TRACK_ADD_BANNER_CLICKED_EVENT, TRACK_BANNER_ADDED_EVENT, TRACK_BANNER_CONTENT_SELECTED_EVENT, TRACK_BANNER_CROPPED_EVENT, TRACK_BANNER_FILTERED_EVENT, TRACK_CROP_BANNER_CLICKED_EVENT, TRACK_FILTER_BANNER_CLICKED_EVENT } from "src/constants/adoption/eventTypes";
import { useTrackEventForAdoption } from "src/query/adoption";
import { SettingsModule } from "src/types/settings/common";
import { AddBannerClicked, BannerAdded, BannerContentSelected, BannerCropped, BannerFiltered, CropBannerClicked, FilterBannerClicked } from "src/types/adoption/settings/accountManagement";
import _ from "lodash";

export const useBannerAdoption = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.ACCOUNT_MANAGEMENT);

  const trackCropBannerClicked = ({ collectionName, bannerType, sourceCta }: CropBannerClicked) => {
    trackEvent({
      event: TRACK_CROP_BANNER_CLICKED_EVENT,
      properties: {
        collectionName: collectionName || "",
        banner_type: _.capitalize(bannerType),
        source_cta: sourceCta,
      },
    });
  };

  const trackBannerAdded = ({ collectionName, bannerType, sourceCta }: BannerAdded) => {
    trackEvent({
      event: TRACK_BANNER_ADDED_EVENT,
      properties: {
        collection_name: collectionName || "",
        banner_type: _.capitalize(bannerType),
        source_cta: sourceCta,
      },
    });
  };

  const trackAddBannerClicked = ({ sourceCta, collectionName }: AddBannerClicked) => {
    trackEvent({
      event: TRACK_ADD_BANNER_CLICKED_EVENT,
      properties: {
        source_cta: sourceCta,
        collection_name: collectionName || "",
      },
    });
  };

  const trackFilterBannerClicked = ({ collectionName, bannerType, sourceCta }: FilterBannerClicked) => {
    trackEvent({
      event: TRACK_FILTER_BANNER_CLICKED_EVENT,
      properties: {
        collection_name: collectionName || "",
        banner_type: _.capitalize(bannerType),
        sourceCta,
      },
    });
  };

  const trackBannerFilteredEvent = ({ collectionName, bannerType, sourceCta }: BannerFiltered) => {
    trackEvent({
      event: TRACK_BANNER_FILTERED_EVENT,
      properties: {
        collection_name: collectionName || "",
        banner_type: _.capitalize(bannerType),
        sourceCta,
      },
    });
  };

  const trackBannerContentSelected = ({ bannerType, sourceCta }: BannerContentSelected) => {
    trackEvent({
      event: TRACK_BANNER_CONTENT_SELECTED_EVENT,
      properties: {
        banner_type: _.capitalize(bannerType),
        sourceCta,
      },
    });
  };

  const trackBannerCropped = ({ bannerType, sourceCta }: BannerCropped) => {
    trackEvent({
      event: TRACK_BANNER_CROPPED_EVENT,
      properties: {
        banner_type: _.capitalize(bannerType),
        sourceCta,
      },
    });
  };

  return {
    trackCropBannerClicked,
    trackBannerAdded,
    trackAddBannerClicked,
    trackFilterBannerClicked,
    trackBannerFilteredEvent,
    trackBannerContentSelected,
    trackBannerCropped
  };
};



